import styled from 'styled-components'

import { colors } from '@/config/global-parameters'

const HorizontalSeparator = styled.div`
  width: 100%;
  background-color: ${colors.colorGrey17};
  height: 1px;
`

export default HorizontalSeparator
